import { ProfilePicture, ProfilePictureWrapper } from "./StyledComponents";

interface Props {
    imgageSource: string;
}

const Profile = ({ imgageSource }: Props) => (
    <ProfilePictureWrapper>
        <ProfilePicture src={imgageSource} />
    </ProfilePictureWrapper>
);

export default Profile;
